"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbAndroidBData = exports.MbIosBData = void 0;
const framework_1 = require("../../../framework");
const changeContextMobile = (context, changeAntiFraudContext) => context && changeAntiFraudContext(context).catch(e => console.error(e));
class MbIosBData extends framework_1.IosBData {
    constructor(baseUrl, slaveUrl, changeAntiFraudContext) {
        super(baseUrl, slaveUrl);
        this.changeAntiFraudContext = changeAntiFraudContext;
    }
    setContext(context) {
        changeContextMobile(context, this.changeAntiFraudContext);
    }
}
exports.MbIosBData = MbIosBData;
class MbAndroidBData extends framework_1.AndroidBData {
    constructor(url, changeAntiFraudContext) {
        super(url);
        this.changeAntiFraudContext = changeAntiFraudContext;
    }
    setContext(context) {
        changeContextMobile(context, this.changeAntiFraudContext);
    }
}
exports.MbAndroidBData = MbAndroidBData;
//# sourceMappingURL=platform.js.map